// extracted by mini-css-extract-plugin
module.exports = {"facebook":"Facebook-module--facebook--XJ22q"};